<template>
    <div>
        <v-card elevation="0">
            <v-card color="#FFCC80" elevation="0" height="100px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-account-circle-outline</v-icon>
                    &nbsp;Account Manager
                </v-card-title>
            </v-card>
            <Manager />
        </v-card>
    </div>
</template>
<script>
import Manager from "../../../components/Admin/AccountManager/Manager.vue"
export default {
    components: {
        Manager
    }
}
</script>